var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutForService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#00B2B2",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.222 28.6911V25.9672C34.222 25.5874 34.0758 25.2238 33.8117 24.9496L32.3594 23.4424H21.3642L19.5402 24.9354C19.2009 25.2136 19.0039 25.63 19.0039 26.0688V28.6891",
    stroke: "#00B2B2",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1594 25.7641L32.307 23.4424H21.0234L22.0858 25.7316C22.3295 26.2557 22.8536 26.5908 23.4325 26.5908H29.8269C30.3916 26.5908 30.9075 26.2699 31.1573 25.7641H31.1594Z",
    stroke: "#00B2B2",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1203 18.6016H20.4494C19.774 18.6016 19.2266 19.149 19.2266 19.8244V22.1055C19.2266 22.7808 19.774 23.3283 20.4494 23.3283H33.1203C33.7957 23.3283 34.3431 22.7808 34.3431 22.1055V19.8244C34.3431 19.149 33.7957 18.6016 33.1203 18.6016Z",
    stroke: "#00B2B2",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8516 19.126V20.3894",
    stroke: "#00B2B2",
    strokeWidth: 1.2,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9727 19.126V20.3894",
    stroke: "#00B2B2",
    strokeWidth: 1.2,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9745 18.3115H36.6406",
    stroke: "#00B2B2",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1249 18.3232H14.793",
    stroke: "#00B2B2",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3398 21.0879H39.485",
    stroke: "#00B2B2",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2236 21.0879H14.4766",
    stroke: "#00B2B2",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50391 20.1367H12.2334",
    stroke: "#00B2B2",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74609 22.6885H12.2311",
    stroke: "#00B2B2",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2308 25.0156H9.98828",
    stroke: "#00B2B2",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutForService);
export default __webpack_public_path__ + "static/media/outForService.bc977662dd7fc8764e46b6633bc96bed.svg";
export { ForwardRef as ReactComponent };